import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TextFieldProps } from '@mui/material';

import BaseTextField from '../../../../core/presentation/components/base-text-field/base-text-field';

export type NameTextFieldProps = TextFieldProps & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  errorText?: string;
};

const NameTextField = (props: NameTextFieldProps) => {
  const { t } = useTranslation(['components']);
  return (
    <Controller
      name='name'
      control={props.control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <BaseTextField
          onChange={onChange}
          value={value || ''}
          error={!!error}
          helperText={error ? props.errorText ?? t('nameInvalid') : undefined}
          id='name'
          name='name'
          label={t('name')}
          variant='filled'
          type='name'
          inputProps={{ maxLength: 256 }}
          required
        />
      )}
    />
  );
};

export default NameTextField;
